import React, { useState } from "react";
import {
  Box,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  IconButton,
  Typography,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import {
  Dashboard,
  AccountBalance,
  History,
  Person,
  Settings,
  Group,
  Menu,
  ChevronLeft,
  HeadsetMic as HeadsetMicIcon, // Replace HelpOutline with HeadsetMic
  ElectricBolt as SolarIcon,
} from "@mui/icons-material";
import {
  useNavigate as useRouterNavigate,
  useLocation,
  Link,
} from "react-router-dom";

const Navigation = () => {
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const navigate = useRouterNavigate();
  const location = useLocation();

  const menuItems = [
    { text: "Dashboard", icon: <Dashboard />, path: "/dashboard" },
    { text: "Transactions", icon: <History />, path: "/transactions" },
    { text: "Profile", icon: <Person />, path: "/profile" },
    { text: "My Referrals", icon: <Group />, path: "/referrals" },
    { text: "Settings", icon: <Settings />, path: "/settings" },
    // { text: "Support", icon: <HeadsetMicIcon />, path: "/support" },
    // {
    //   text: "Own A Solar",
    //   icon: <SolarIcon />,
    //   path: "/solar",
    //   description: "Get a free 1KW Solar Power System",
    // },
  ];

  const drawer = (
    <Box sx={{ width: 250, pt: 2 }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          px: 2,
          mb: 3,
        }}
      >
        <AccountBalance sx={{ mr: 1, color: "primary.main" }} />
        <Typography variant="h6" color="primary">
          ATKLand
        </Typography>
        {isMobile && (
          <IconButton onClick={() => setOpen(false)} sx={{ ml: "auto" }}>
            <ChevronLeft />
          </IconButton>
        )}
      </Box>

      <List>
        {menuItems.map((item) => (
          <ListItem
            button
            key={item.text}
            onClick={() => {
              navigate(item.path);
              if (isMobile) setOpen(false);
            }}
            sx={{
              bgcolor:
                location.pathname === item.path
                  ? "action.selected"
                  : "transparent",
              borderRadius: 1,
              mx: 1,
              mb: 1,
            }}
          >
            <ListItemIcon
              sx={{
                color:
                  location.pathname === item.path
                    ? "primary.main"
                    : "text.secondary",
              }}
            >
              {item.icon}
            </ListItemIcon>
            <ListItemText
              primary={item.text}
              sx={{
                color:
                  location.pathname === item.path
                    ? "primary.main"
                    : "text.primary",
              }}
            />
          </ListItem>
        ))}
        <ListItem
          button
          component={Link}
          to="/dashboard/support"
          selected={location.pathname === "/dashboard/support"}
          sx={{
            bgcolor:
              location.pathname === "/dashboard/support"
                ? "action.selected"
                : "transparent",
            borderRadius: 1,
            mx: 1,
            mb: 1,
          }}
        >
          <ListItemIcon>
            <HeadsetMicIcon
              sx={{
                color:
                  location.pathname === "/dashboard/support"
                    ? "primary.main"
                    : "text.secondary",
              }}
            />
          </ListItemIcon>
          <ListItemText
            primary="Help & Support"
            sx={{
              color:
                location.pathname === "/dashboard.support"
                  ? "primary.main"
                  : "text.primary",
            }}
          />
        </ListItem>
      </List>
    </Box>
  );

  return (
    <>
      {isMobile && (
        <IconButton
          color="inherit"
          onClick={() => setOpen(true)}
          sx={{ position: "fixed", top: 16, left: 16, zIndex: 1100 }}
        >
          <Menu />
        </IconButton>
      )}

      <Box
        component="nav"
        sx={{
          width: { md: 250 },
          flexShrink: { md: 0 },
        }}
      >
        {isMobile ? (
          <Drawer
            variant="temporary"
            open={open}
            onClose={() => setOpen(false)}
            ModalProps={{ keepMounted: true }}
          >
            {drawer}
          </Drawer>
        ) : (
          <Drawer
            variant="permanent"
            sx={{
              "& .MuiDrawer-paper": {
                width: 250,
                boxSizing: "border-box",
                border: "none",
                bgcolor: "background.paper",
              },
            }}
            open
          >
            {drawer}
          </Drawer>
        )}
      </Box>
    </>
  );
};

export default Navigation;
